export const name = "ST_DISJOINT";
export const summary = `Checks if two \`GEOGRAPHY\` values are disjoint (don't intersect).`;
export const reference = `
## ST_DISJOINT

Checks if two \`GEOGRAPHY\` values are disjoint (don't intersect).

\`\`\`
ST_DISJOINT(geography_1, geography_2)
\`\`\`

### Description

Returns \`TRUE\` if the intersection of \`geography_1\` and \`geography_2\` is empty, that is, no point in \`geography_1\` also appears in \`geography_2\`.

\`ST_DISJOINT\` is the logical negation of \`ST_INTERSECTS\`.


### Return type

\`BOOL\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/geography_functions
`;
